module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e49d52e74b7689a0727d.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.ttf
// module chunks = 2